import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

export function useApiConfig() {
  const { data } = useQuery({
    queryKey: ['apiConfig'],
    queryFn: () => api.get('/config'),
    staleTime: Infinity,
  })
  return data ?? {}
}
